{
    "SignInWith_Title": "Anmeldung mit",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Mit anderen Optionen anmelden"
}